module.exports = __webpack_public_path__ + "img/58.d28c1b77.jpg";